import * as React from 'react';

import { motion } from 'framer-motion';
import { useTheme } from 'styled-components';

interface DotsCircleIconProps {
  className?: string;
  isInvertedColor?: boolean;
  isWhite?: boolean;
  onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

export const DotsCircleIcon: React.FC<DotsCircleIconProps> = (props) => {
  const theme = useTheme();

  const moveLeft = {
    rest: {
      x: 0,
    },
    hover: {
      x: -3,
      transition: {
        ease: [0.0, 0.0, 0.25, 1.0],
        duration: 0.15,
      },
    },
  };

  const moveRight = {
    rest: {
      x: 0,
    },
    hover: {
      x: 3,
      transition: {
        ease: [0.0, 0.0, 0.25, 1.0],
        duration: 0.15,
      },
    },
  };

  const getBgCircleColor = (isInvertedColor?: boolean, isWhite?: boolean) => {
    if (isInvertedColor) {
      return theme.colors.primaryHover;
    }
    if (isWhite) {
      return theme.colors.differentBackground;
    }
    return theme.colors.box;
  };

  const getDotsColor = (isInvertedColor?: boolean) => {
    if (isInvertedColor) {
      return theme.colors.background;
    }
    return theme.colors.primaryHover;
  };

  return (
    <motion.svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      className={props.className}
      initial="rest"
      whileHover="hover"
      whileTap="hover"
      animate="rest"
      onClick={(ev) => (props.onClick ? props.onClick(ev) : null)}
    >
      <circle
        fill={getBgCircleColor(props.isInvertedColor, props.isWhite)}
        cx="20"
        cy="20"
        r="20"
      />
      <motion.circle
        variants={moveLeft}
        fill={getDotsColor(props.isInvertedColor)}
        cx="14"
        cy="20"
        r="2"
      />
      <circle
        fill={getDotsColor(props.isInvertedColor)}
        cx="20"
        cy="20"
        r="2"
      />
      <motion.circle
        variants={moveRight}
        fill={getDotsColor(props.isInvertedColor)}
        cx="26"
        cy="20"
        r="2"
      />
    </motion.svg>
  );
};

export default DotsCircleIcon;
